<app-page-container>
  <div class="content">
    <div class="div__header">
      <app-header class="c-header" class="center" appTitle="Histórico de pedidos" divider>
        <app-botao-voltar class="c-header__button"></app-botao-voltar>
      </app-header>
    </div>
  </div>

  <div class="div__content">
    <div class="card__content">
      <h5>Sobre o pedido</h5>
      <app-datails-card>
        <p>
          <span>Código do pedido: </span>{{detalhesPedido?.codPedido}}<br />
          <span>Status do pedido: </span>{{detalhesPedido?.status}}<br />
          <br />
          <span>Cliente: </span>{{detalhesPedido?.nomeCliente}}<br />
          <span>E-mail: </span>{{detalhesPedido?.emailCliente}}<br />
          <span>Telefone: </span>{{detalhesPedido?.fone ?? 'Não Registrado'}}<br />
          <br />
          <span>Referência: </span>{{detalhesPedido?.numSerie ?? 'Não Registrado'}}<br />
          <span>Descrição: </span>{{detalhesPedido?.numSerie ?? 'Não Registrado'}}<br />
          <span>Quantidade desejada: </span>{{detalhesPedido?.numSerie ?? 'Não Registrado'}}<br />
          <span>Em estoque: </span>{{detalhesPedido?.marca ?? 'Não Registrado'}}<br />
          <span>Vazios (devolução): </span>{{detalhesPedido?.modelo ?? 'Não Registrado'}}<br />
          <br />
          <span>Endereço de atendimento: </span>
          {{detalhesPedido?.rua}},
          <br />
          {{detalhesPedido?.numero}},
          {{detalhesPedido?.bairro}} -
          {{detalhesPedido?.cidade}},
          {{detalhesPedido?.estado}} -
          {{detalhesPedido?.cep}}<br />
        </p>

        <app-tabela [cabecalhos]="['Referência', 'Produto', 'Quantidade']" [items]="detalhesPedido.itens">
          <tr>
            <td><strong>Referência</strong></td>
            <td><strong>Produto</strong></td>
            <td><strong>Quantidade</strong></td>
          </tr>
          <ng-container *ngFor="let item of detalhesPedido.itens">
            <tr>
              <td>{{item.referencia}}</td>
              <td>{{item.produto}}</td>
              <td>{{item.quantidade}}</td>
            </tr>
          </ng-container>
        </app-tabela>

        <p>
          <span>Responsável: </span>{{detalhesPedido?.abertoPor ?? 'Não Registrado'}} <br />
          <span>Criado em: </span>{{detalhesPedido?.dataAbertura || '' | date: "dd/MM/yyyy, hh:mm"}} <br />
          <br />
          <span *ngIf="detalhesPedido?.dataFechamento">Data de entrega: </span>{{detalhesPedido?.dataFechamento || '' |
          date: "dd/MM/yyyy, hh:mm"}} <br />
        </p>

      </app-datails-card>
    </div>
  </div>
</app-page-container>